import {request, exportExcel} from "@/utils/request.js"
//登录
export function login (data) {
    return request({
      url:"/login",
      method: 'post',
      data
  })
}
//退出登录
export function logout() {
  return request({
    url: '/logout',
    method: 'get'
  })
}
//密码加密
// export function passwordEncryption() {
//   return request({
//     url: '/convert',
//     method: 'get'
//   })
// }

//个人中心首页
export function userIndexApi () {
    return request({
      url:`/personal/center/details`,
      method: 'get',
  })
}

//个人基本信息
export function userInfoApi () {
    return request({
      url:"/personal/center/info",
      method: 'get',
  })
}
//球员手册
export function userManualApi () {
    return request({
      url:"/personal/center/manual",
      method: 'get',
  })
}
//球员手册下载
export function userManualDownloadApi (data) {
    return request({
      url:"/configure/downloadFile",
      method: 'get',
      data,
      responseType:'blob'
  })
}

//银行账户
export function bankInfoApi () {
    return request({
      url:"/personal/center/bankInfo",
      method: 'get',
  })
}

//更新银行账户信息
export function updateBankInfoApi (data) {
  return request({
    url:"/personal/center/updateBank",
    method: 'post',
    data
 })
}

//修改密码
export function passwordAPI (data) {
  return request({
      url:"/personal/center/updatePassWord",
      method: 'post',
      data
  })
}
//首页奖金榜
export function bonusLeaderboardApi(data) {
    return request({
      url:"/event/bonus/home/list",
      method: 'get',
      data
  })
}
//首页内容列表
export function contentsListApi(data) {
    return request({
      url: '/system/info/list',
      method: 'get',
      data:data
  })
}
//首页内容列表
export function contentsListInfoApi(data) {
    return request({
      url: '/system/info/pageList',
      method: 'get',
      data:data
  })
}
// 比赛信息
export function gamestationInfo(data) {
  return request({
    url: '/gamestation/getInfo',
    method: 'get',
    data:data
  })
}

// 首页比分直播
export function indexScore () {
  return request({
    url:`gamestation/getHoleScore`,
    method: 'get',
  })
}


//奖励下载
export function downloadAward () {
  return exportExcel("/personal/center/export",{}, null, "奖金信息")
}
//新闻详情
export function newsDetails(id) {
  
  return request({
    url: `/system/info/${id}`,
    method: 'get',
  })
  
}
//积分榜
export function pointsList() {
  
  return request({
    url: `/event/points/home/list`,
    method: 'get',
  })
  
}



// WEBPACK FOOTER //
// ./src/api/user/index.js